import React from 'react'
import Navigation from '../components/Navigation'
import Gallery from '../components/IndexGallery'
import { useStaticQuery, graphql, StaticQuery } from "gatsby"

import '../stylesheets/reset.css'
import '../stylesheets/style.css'

const Home = props => {

  const data = useStaticQuery(graphql`
    query landingPage {
      allStrapiIndexPage {
        edges {
          node {
            id
            Images {
              id
              image {
                childImageSharp {
                  fluid {
                    aspectRatio
                    base64
                    originalImg
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
      allStrapiCollection {
        edges {
          node {
            id
            name
            Images {
              name
              image {
                childImageSharp {
                  fluid {
                    aspectRatio
                    base64
                    originalImg
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  
  console.log('TEST')

  console.log(data)

  return (
    <div id='root'>
      <Navigation allStrapiCollection={data.allStrapiCollection}/>
      <Gallery images={data.allStrapiIndexPage.edges[0].node.Images}/>
    </div>
  )
}

export default Home

